"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.list.name': '测试名称',
    'botTest.list.date': '测试日期',
    'botTest.list.testersCount': '测试者',
    'botTest.list.targetsCount': '目标',
};
